import React, { useState } from "react";
import { AppShape } from "@eave/shared/types/api";
import { SelfEmployed } from "@eave/shared/types/api/income";
import { formatCurrency } from "@eave/shared/utils/currency";
import APIClient from "web_modules/APIClient";
import { verticalHeaderTRUSTable } from "./shared";

const styles = require("./styles.module.scss");

export const isSelfEmployed = (sections): boolean =>
  Object.keys(SelfEmployed).some(type => {
    const income = sections.find(section => section.section_key === type) || {};
    return +income.monthly_total > 0;
  });

interface Props {
  app: AppShape;
  borrowerNum: 1 | 2;
}

const BorrowerInfo: React.FC<Props> = ({ app, borrowerNum }: Props) => {
  const [hasOwnedProperty, setOwnedProperty] = useState<string>();

  React.useEffect(() => {
    APIClient.get(`/uw/${app.id}/declarations`, {}).then(({ declarations }) => {
      let interest = "N/A";
      if (declarations.length) {
        interest = declarations[borrowerNum - 1].property_ownership_interest ? "Yes" : "No";
      }
      setOwnedProperty(interest);
    });
  }, [app.id, borrowerNum]);

  const { sections } = app.income_summary.tax_summary;
  const table1 = [
    { label: "First Name", value: app[`borrower${borrowerNum}_first_name`] },
    { label: "Middle Name", value: app[`borrower${borrowerNum}_middle_name`] },
    { label: "Last Name", value: app[`borrower${borrowerNum}_last_name`] },
    { label: "Credit Score", value: app.decision[`credit_score_borrower_${borrowerNum}`] },
  ];
  const table2 = [
    { label: "Monthly Income", value: formatCurrency(app.decision.monthly_income, 2, 2) },
    {
      label: "Self-Employed",
      value: isSelfEmployed(sections) ? "Yes" : "No",
    },
    { label: "Nontraditional Credit", value: "No" },
    { label: "Borrower Intent to Occupy", value: app.property_usage === "primary" ? "Yes" : "No" },
    { label: "Property Ownership in Last 3 Years", value: hasOwnedProperty },
  ];
  return (
    <>
      <h2>{`Borrower ${borrowerNum} Information`}</h2>
      <div className={styles.table}>
        {verticalHeaderTRUSTable(table1)}
        {verticalHeaderTRUSTable(table2)}
      </div>
    </>
  );
};

export default BorrowerInfo;
